import {ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, OnInit} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {
  ApiIndicatorGetRequestParams,
  IndexEntityService,
  IndicatorService,
  ReferenceService
} from '../../../apiModule1';
import {AsyncPipe, NgClass, NgStyle} from '@angular/common';
import {map} from 'rxjs/operators';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {MultiSelect2Component} from '../../../../shared/components/multi-select2/multi-select2.component';
import {implementers} from '../dialog/dialog.component';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {OnInputChange} from '../../OnInputChange';

@Component({
  selector: 'pas-filter-dialog-indicators',
  standalone: true,
  imports: [
    MatIcon,
    MatIconButton,
    ReactiveFormsModule,
    MatButton,
    NgClass,
    NgStyle,
    MultiSelect2Component,
    AsyncPipe,

  ],
  templateUrl: './filter-dialog.component.html',
  styleUrls: ['./filter-dialog.component.scss', '../../index-entity/filter-dialog/filter-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterDialogComponent implements OnInit {
  cdr = inject(ChangeDetectorRef);
  dialogRef = inject(MatDialogRef<FilterDialogComponent>);
  referenceService = inject(ReferenceService);
  data: Record<string, any> = inject(MAT_DIALOG_DATA)
  indexService = inject(IndexEntityService);
  indicatorService = inject(IndicatorService);
  private destroyRef = inject(DestroyRef)

  indexes: IndexEntry[] = []

  archiveStatuses: Status[] = []
  filteredIndexes: Observable<IndexEntry[]> = of([])
  dataCriterions: Criterion[] = []

  get filteresCriterionsMaped(): Observable<string[]> {
    return this.filteredIndexes.pipe(map(v => v.map(i => i.name)))
  }

  get dataCriterionsNames(): string[] {
    return this.dataCriterions.map(v => v.name);
  }


  get archiveStatusesNames(): string[] {
    return this.archiveStatuses.map(v => v.name);
  }


  periods: CriterionPeriod[] = []

  implementers = implementers;
  indicators: Indicator[] = []
  cbs: { id: number, name: string}[] = []
  searchCbs$ = new BehaviorSubject<string>('');
  filteredCbs$: Observable<{ id: number, name: string}[]> = of([]);

  form = new FormGroup({
    archive: new FormControl(this.data && this.data['statusIds'] || []),
    indicator: new FormControl(this.data && this.data['indicatorIds'] || []),
    period: new FormControl(this.data && this.data['periodIds'] || []),
    index: new FormControl(this.data && this.data['indexIds'] || []),
    implementerTypes: new FormControl(this.data && this.data['implementerTypes'] || []),
    cbTypeIds: new FormControl(this.data && this.data['cbTypeIds']||[] )
  })


  dataIndex: OnInputChange<IndexEntry> = new OnInputChange(this.indexService, 'apiIndexFilterlistGet', 'indicator')
  dataIndicator: OnInputChange<Indicator> = new OnInputChange(this.indicatorService, 'apiIndicatorFilterlistGet', 'indicator')

  onNoClick(): void {
    this.dialogRef.close();
  }


  ngOnInit(): void {
    console.log('filter-dialog data', this.data);

    this.form.get('cbTypeIds')?.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(v => {
        console.log('cbTypeIds', v);
      })


    this.referenceService.apiReferencePeriodsGet().pipe(map(v => v.values))
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((v: any) => {
        this.periods = v;
      })


    this.referenceService.apiReferenceStatusesGet().pipe(map(v => v.values))
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((v: Status[]) => {
        this.archiveStatuses = v;
      })

    this.referenceService.apiReferenceCbtypesGet()
      .pipe(map(v => v.values))
      .subscribe((v: { id: number, name: string}[])=>{
        this.cbs = v;
        this.filteredCbs$ = this.searchCbs$.pipe(map(v=>{
          const res = this.cbs.filter(cb => cb.name?.toLowerCase().includes(v.toLowerCase()));
          return res;
        }))
        //--- заполняем form.get('cbTypeIds')
        if(!this.data || !this.data['cbTypeIds']) return;
        const matchedCbs = this.cbs.filter(cb => this.data['cbTypeIds'].includes(cb.id));
        this.form.get('cbTypeIds')?.setValue(matchedCbs, { emitEvent: false });
      })





    this.dataIndex.on({pageIndex: 0}).subscribe(v => {
      this.indexes = v;
      this.cdr.markForCheck();
    })
    this.dataIndicator.on({pageIndex: 0}).subscribe(v => {
      this.indicators = v;
      this.cdr.markForCheck();
    })

  }


  onReset(): void {
    this.form.reset();
  }

  onApply() {
    const cbControl = this.form.get('cbTypeIds');
    const cb = !!cbControl?.value
      && !!cbControl.value?.length
      && cbControl.value.map((v: any) => v.id);

    const res: ApiIndicatorGetRequestParams = {
      statusIds: this.form.get('archive')!.value,
      indicatorIds: this.form.get('indicator')!.value,
      periodIds: this.form.get('period')!.value,
      indexIds: this.form.get('index')!.value,
      cbTypeIds: cb || [],
      implementerTypes: this.form.get('implementerTypes')!.value
    }

    this.dialogRef.close(res);
  }


}
